import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { getUserRole } from '../../../../shared/functions/UserRole/userRoleManagment.functions'
import { GetFulfillmentOrdersRequest, GetFulfillmentOrdersSuccessResponse } from './getFulfillmentOrders.types'

export const getFulfillmentOrdersApi = async (
  request: GetFulfillmentOrdersRequest
): Promise<GetFulfillmentOrdersSuccessResponse> => {
  const params: Record<string, string | number> = {}

  if (request.page !== undefined) params.page = request.page
  if (request.limit !== undefined) params.limit = request.limit
  if (request.status) params.status = request.status
  if (request.search) params.search = request.search
  if (request.sortBy) params.sortBy = request.sortBy
  if (request.sortOrder) params.sortOrder = request.sortOrder

  const response = await configureRequest({
    url: urls.fulfillmentOrders.getFulfillmentOrders,
    method: 'GET',
    params,
    headers: {
      'X-User-Role': getUserRole() || ''
    }
  })

  return response as GetFulfillmentOrdersSuccessResponse
}
